module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/210-grenada-7c392d3c8eebe48ff230503f0b7ee298.svg";